// extracted by mini-css-extract-plugin
export default {"root":"CheckboxGroup__root___OVtDk","button":"CheckboxGroup__button___ok0wt","indicator":"CheckboxGroup__indicator___KQ7wA","icon":"CheckboxGroup__icon___aX9Xv"};